import React, { useCallback } from 'react';
const Checkbox = ({
  checked,
  defaultChecked,
  name,
  id,
  onChange = () => {},
  rawInputProps = {}
}) => {
  const handleChange = useCallback(({
    target
  }) => {
    onChange(target.checked, name);
  }, [name, onChange]);
  return /*#__PURE__*/React.createElement("input", Object.assign({
    className: "ebds-checkbox",
    type: "checkbox",
    id: id,
    checked: checked,
    defaultChecked: defaultChecked,
    onChange: handleChange
    /* eslint-disable-next-line react/jsx-props-no-spreading */
  }, rawInputProps));
};
export default Checkbox;